var React = require('react');

function Dash (props) {
    return React.createElement("svg",props,React.createElement("rect",{"width":"21","height":"2","rx":"1","fill":"#F9B2A9"}));
}

Dash.defaultProps = {"width":"21","height":"2","viewBox":"0 0 21 2","fill":"none"};

module.exports = Dash;

Dash.default = Dash;
